export default "__VITE_ASSET__CdRm_i5w__"